export default __webpack_public_path__ + "static/11.07-11c8db6997b3f87e6bd070693098ef0b.png";